import React, { useState, useEffect } from "react";
import CheckoutCustomizedSteppers from "./CheckoutSlider";
import { Box, CircularProgress } from "@mui/material";
import Header from "../Header/Header";
import OrderSummary from "./OrderSummary";
import PaymentDetails from "./PaymentDetails";
import DeliveryDetails from "./DeliveryDetails";
import { useSelector } from "react-redux";
import { useAddSubscriptionMutation } from "api/subscription.js";
import { useAddPaymentMutation, useGetPaymentMethodQuery } from "api/payment.js";
import Swal from "sweetalert2";
import { useNavigate } from "react-router";
import Footer from "components/Footer/Footer";

export default function Checkout({ setshowsubTypeFunc, CheckTypeFunc, selectSubType }) {
  const navigate = useNavigate();
  // let cart = useSelector((state) => state.cart);
  const { selectedDishes } = useSelector((state) => state.dishes);
  // const updatedSelectedDishes = selectedDishes.map(dish => ({
  //   ...dish,
  //   pricePerDay: 10// Add your price value here for each object
  // }));
  const mealplanId = selectedDishes[0]?.dish?.mealPlan
  console.log(mealplanId);
  const [total, setTotalPrice] = React.useState(0);
  const [userId, setuserId] = useState("");
  const [addSubscription, { isLoading }] = useAddSubscriptionMutation();
  const { data: PaymentMethods, isLoading: isSuccess } =
    useGetPaymentMethodQuery();
  const [addPayment, { isloading }] = useAddPaymentMutation()
  useEffect(() => {
    const user = localStorage.getItem("user");
    if (user) {
      const parsedData = JSON.parse(user);
      const userIdFromStorage = parsedData?.profile?._id;
      // console.log("usre", userIdFromStorage);
      if (userIdFromStorage) {
        setuserId(userIdFromStorage);
      }
      // console.log("Id", userId);
    }
  }, []);
  console.log(total)
  const catererId = localStorage.getItem("catererId")
  const [subDetails, setsubDetails] = React.useState({
    // user: userId,
    // subType: "personal",
    // startDate: "",
    // endDate: "",
    // noOfDays: 1,
    // promotionCode: "",
    // deliveryTime: "",
    // deliveryAddress: "",
    // deliveryInstruction: "",
    // totalPayment: 0,
    menu: [...selectedDishes],
    subId: " 121+ c",
    user: userId, //arhi
    subType: "Personal Subscription", //arhi
    subPeriod: selectSubType, //arhi
    mealplanId: mealplanId,
    caterer: "chek onewer",
    catererId: catererId,
    cuisine: "check cyuisisne",
    quantity: selectedDishes.length,
    noOfDays: 1, //arhi
    startDate: "", //arhi
    endDate: "", //arhi
    deliveryTime: "9am", //arhi
    deliveryAddress: "hyderaabad", //arhi
    deliveryInstruction: "",//arhi
    // pricePerDay: 10,
    totalPrice: total,
    promotionCode: "", //arhi
    paymentInfo: "",
    paymentId: userId,
    paymentMethod: "",
    totalPayment: "",
    // paymethod : "",
    status: "request"
  });

  React.useEffect(() => {
    setsubDetails((prevSubDetails) => ({
      ...prevSubDetails,
      user: userId,
      totalPrice: total
    }));
  }, [userId, total]);


  function generateCustomId(length) {
    const characters = '0123456789abcdef';
    const charactersLength = characters.length;
    let customId = '';

    for (let i = 0; i < length; i++) {
      customId += characters.charAt(Math.floor(Math.random() * charactersLength));
    }

    return customId;
  }

  // Example usage:

  const handleSubscribe = () => {
    const customId = generateCustomId(24); // Since the provided example has 24 characters
    console.log(customId); // Output will be something like: "65704a69314028e5a2df15da"
    // console.log("IDDD", userId)
    let temp = { ...subDetails };
    temp.totalPayment = total;
    // temp.user= userId
    console.log('userId', userId)
    addSubscription(temp).then((res) => {
      console.log(res)
      console.log(res?.error)
      console.log(res?.error?.originalStatus)
      if (res?.error?.originalStatus === 401) {
        Swal.fire("Token has expired", "", "error");
      } else if (res.data.status) {
        navigate("/subscriptionsuccess");
      }
      else {
        Swal.fire("Something went wrong", "", "error");
      }
    })
    addPayment({ amount: total, userId: userId, type: "deposit", customId: customId }).then((res) => {
      console.log(res)
      console.log(res?.error)
      console.log(res?.error?.originalStatus)
      // if (res?.error?.originalStatus === 401) {
      //   Swal.fire("Token has expired", "", "error");
      // } else if (res.data.status) {
      //   navigate("/subscriptionsuccess");
      // }
      // else {
      //   Swal.fire("Something went wrong", "", "error");
      // }
    })
  };

  return isLoading ? (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      minHeight="100vh"
    >
      <CircularProgress />
    </Box>
  ) : (
    <>
      <Box component="container">
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            mt: "24px",
            mb: "40px",
          }}
        >
          <CheckoutCustomizedSteppers />
        </Box>

        <Box
          sx={{
            display: "flex",
            flexDirection: { lg: "row", md: "row", sm: "column", xs: "column" },
            justifyContent: "center",
            alignItems: {
              lg: "start",
              md: "start",
              sm: "center",
              xs: "center",
            },
            width: "100%",
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              width: { lg: "50%", md: "50%", sm: "93%", xs: "88%" },
            }}
          >
            <Box>
              <OrderSummary
                setsubDetails={setsubDetails}
                subDetails={subDetails}
              />
            </Box>
            <Box mt="30px" sx={{ width: "100%" }}>
              <DeliveryDetails
                setsubDetails={setsubDetails}
                subDetails={subDetails}
              />
            </Box>
          </Box>

          <Box
            sx={{
              width: { lg: "45%", md: "45%", sm: "93%", xs: "88%" },
              ml: { lg: "10px", md: "10px", sm: "0px", xs: "0px" },
            }}
          >
            <PaymentDetails
              setsubDetails={setsubDetails}
              subDetails={subDetails}
              handleSubscribe={handleSubscribe}
              total={total}
              setTotalPrice={setTotalPrice}
              PaymentMethods={PaymentMethods}
            />
          </Box>
        </Box>
      </Box>
      <Box>
        <Footer />
      </Box>
    </>
  );
}
